module.exports = __webpack_public_path__ + "static/media/blue-rose.e29c869c.png";